import { Loader2 } from 'lucide-react'

export const Loader = () => (
  <Loader2 data-testid="loader" className="m-auto animate-spin" size="48" />
)
